import { Button } from "antd-mobile";
import cls from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import "./index.scss";

type TCountDownButtonProps = {
  children: React.ReactNode;
  className?: string;
  waiting: boolean;
  count: number;
  onSendCode: () => Promise<any>;
};

const CountDownButton: React.FC<TCountDownButtonProps> = ({
  children,
  className,
  waiting,
  count,
  onSendCode,
}) => {
  const { t } = useTranslation();
  const interval = useRef<NodeJS.Timeout>();

  useEffect(() => {
    return () => {
      if (interval.current) clearInterval(interval.current);
    };
  }, []);

  const text = waiting
    ? t("sensechat-76", { time: count }) // `${count}s后重试`
    : children;

  return (
    <Button
      className={cls("verify-code", className)}
      color="primary"
      fill="none"
      disabled={waiting}
      onClick={waiting ? () => {} : onSendCode}
      style={{ "--text-color": "#FFFFFF" }}
    >
      {text}
    </Button>
  );
};

export default CountDownButton;
